import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ChangeAssignmentDate } from '../../model/changeassignmentdate';
import { EditLogInfo } from '../../model/editloginfo';
import { AssignmentService } from '../../shared/assignment.service';
import { ChangelogService } from '../../shared/changelog.service';
import { CommonService } from '../../shared/common.service';
import { ReturnObject } from '../../model/returnobject';
import { UserService } from '../../shared/user.service';
import { User } from '../../model/user';
import { StatusMessagesService } from '../../shared/statusmessage.service';

@Component({
  selector: 'end-date-dialog',
  templateUrl: 'end-date-dialog.html',
  styleUrls: ['./end-date-dialog.scss']
})
export class EndDateDialog implements OnInit {
  @Input() assignmentNumber: string = '';
  @Input() department: string = '';
  @Input() assignmentManager: string = '';
  @Input() showMe: boolean = false;
  @Input() isDateSet: boolean = false;
  @Output() onCloseDlg: EventEmitter<boolean> = new EventEmitter<boolean>();

  showLoading: boolean = false;
  dataChanged: boolean = false;
  loggedUser: User = new User();
  logChangesList: EditLogInfo[] = [];
  endDate: string = '';

  constructor(
    private common: CommonService,
    private assignmentApi: AssignmentService,
    private changeLogApi: ChangelogService,
    private userService: UserService,
    private statusMessagesService: StatusMessagesService
  ) { }

  ngOnInit() {
    this.initServices();
  }

  initServices() {
    this.loggedUser = this.userService.getUser();
    this.getChanges();
  }


  getChanges() {
    this.showLoading = true;
    this.changeLogApi.getChanges(this.assignmentNumber, 'Edit End Date')
      .subscribe({
            next: (res: ReturnObject<EditLogInfo[]>) => {
              if (res.isFailure) {
                this.statusMessagesService.showToasterError('Error', 'Failed to load History');
                return;
              }
      
              this.logChangesList = res.value;
            },
            error: (err) => {         
              this.statusMessagesService.showHttpError(err);
            },
            complete: () => {         
                this.showLoading = false;
            }
        }
    );
  }
  
  setAssignmentEndDate(): void {
    let endDate = new Date(this.endDate)
    this.showLoading = true;

    this.assignmentApi.setAssignmentEndDate(new ChangeAssignmentDate(this.assignmentNumber, endDate))
      .subscribe({
            next: (res: ReturnObject<string>) => {
              if (res.isFailure) {
                this.statusMessagesService.showToasterError('Error', res.failureMessage);
                return;
              }
              this.dataChanged = true;
              this.statusMessagesService.showToasterInfo('Saved', res.value);
      
              this.getChanges();
            },
            error: (err) => {         
              this.statusMessagesService.showHttpError(err);
            },
            complete: () => {         
                this.showLoading = false;
            }
        }
    );
  }
  
  removeAssignmentEndDate(): void {
    this.showLoading = true;

    this.assignmentApi.removeAssignmentEndDate(new ChangeAssignmentDate(this.assignmentNumber, new Date()))
      .subscribe({
            next: (res: ReturnObject<string>) => {
              if (res.isFailure) {
                this.statusMessagesService.showToasterError('Error', res.failureMessage);
                return;
              }
              this.dataChanged = true;
              this.getChanges();
              this.statusMessagesService.showToasterInfo('Removed', res.value);
            },
            error: (err) => {         
              this.statusMessagesService.showHttpError(err);
            },
            complete: () => {         
                this.showLoading = false;
            }
        }
    );
  }

  closeDialog() {
    this.showMe = false;
    this.onCloseDlg.emit(this.dataChanged);
  }
  
  showDeleteSymbol(): boolean {
    return this.logChangesList.length > 0 && this.getDateString( this.logChangesList[0].changedTo) != 'No date set';
  }

  getDateString(dateString: string): string {
    return dateString !== '2099-12-31' && dateString !== '12/31/2099'
      ? dateString
      : 'No date set';
  }

  isAllowedToEditEndDate(): boolean {
    return this.loggedUser.accessFeatures.includes('setenddateall')
      || (this.loggedUser.accessFeatures.includes('setenddateown')
        && this.loggedUser.id == this.assignmentManager);
  }

  isValuesSet(): boolean {
    return !this.common.isNullOrWhiteSpace(this.endDate);
  }
}
